import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getAdLabelStyles } from '../styles';

const AdLabelImpl = ({
  i18n, adsLabelClassName, classes, isAdPreviewRefreshEnabled,
}) => (
  <div className={classnames(isAdPreviewRefreshEnabled ? classes.adLabelRefreshedRoot : classes.adLabelRoot, adsLabelClassName)}>
    {i18n.getString('Ad')}
  </div>
);

AdLabelImpl.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  adsLabelClassName: PropTypes.string,
  classes: PropTypes.shape({
    adLabelRoot: PropTypes.string,
  }).isRequired,
};

AdLabelImpl.defaultProps = {
  adsLabelClassName: undefined,
};

export const AdLabel = withUAPLThemedStyles(
  AdLabelImpl,
  getAdLabelStyles,
  { componentName: 'AdLabel' }
);
